import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 80 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 24C4 12.954 12.954 4 24 4c6.542 0 12.351 3.141 16 7.998C43.649 7.141 49.458 4 56 4c11.046 0 20 8.954 20 20s-8.954 20-20 20c-6.542 0-12.351-3.141-16-7.998C36.351 40.859 30.542 44 24 44 12.954 44 4 35.046 4 24Zm33.06-9.06a1.5 1.5 0 0 1 0 2.12l-14 14a1.5 1.5 0 0 1-2.12 0l-8-8a1.5 1.5 0 0 1 2.12-2.12L22 27.878l12.94-12.94a1.5 1.5 0 0 1 2.12 0Zm32 0a1.5 1.5 0 0 1 0 2.12l-14 14a1.5 1.5 0 0 1-2.12 0l-8-8a1.5 1.5 0 0 1 2.12-2.12L54 27.878l12.94-12.94a1.5 1.5 0 0 1 2.12 0Z",
      clipRule: "evenodd"
    }
  )
);
var SvgDoubleTickCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DoubleTickCircleFilled_default = SvgDoubleTickCircleFilled;

export { DoubleTickCircleFilled_default as default };
